import type { ComplianceFocus } from '../complianceFocus';
import { complianceReportPath } from '../complianceFocus';

export type StatsCompliancePrintFilters = {
  vesselId?: string;
  withinDays?: string;
};

export function statsCompliancePrintPath(
  focus: ComplianceFocus,
  filters: StatsCompliancePrintFilters = {},
): string {
  const qs = new URLSearchParams();
  if (filters.vesselId?.trim()) qs.set('vesselId', filters.vesselId.trim());
  if (filters.withinDays?.trim()) qs.set('withinDays', filters.withinDays.trim());
  const s = qs.toString();
  return `${complianceReportPath(focus)}/print${s ? `?${s}` : ''}`;
}

export function statsComplianceListApiUrl(params: URLSearchParams): string {
  const today = new Date().toISOString().slice(0, 10);
  const qs = new URLSearchParams({
    withinDays: params.get('withinDays')?.trim() || '90',
    periodFrom: today,
    periodTo: today,
  });
  const vesselId = params.get('vesselId')?.trim();
  if (vesselId) qs.set('vesselId', vesselId);
  return `/crew/reports/statistics?${qs.toString()}`;
}

export function statsComplianceBackPath(focus: ComplianceFocus): string {
  return complianceReportPath(focus);
}
